import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class SupplierSystemsService {

  constructor(private http: HttpClient) { }

  getSupplierSystems(){
    return this.http.get(`${environment.yomaApiURL}/supplierSystems`);
  }
}
